<template>
  <layout>
    <h4>
      Groups
      <router-link
        :to="{ name: 'location-groups.create' }"
        class="btn btn-sm btn-primary">Create</router-link>
    </h4>
    <pages-base-table
      :resource="resource">

      <template
        slot="title"
        slot-scope="{ item }">
        <a
          :href="item.link"
          target="_blank">
          {{ item.title }}
        </a>
      </template>

    </pages-base-table>
  </layout>
</template>

<script>
import Layout from '../layouts/Default.vue';
import PagesBaseTable from '../components/PagesBaseTable.vue';
import Proxy from './Api';

const resourceBase = 'location-groups';

export default {
	name: 'LocationGroupsIndex',

	components: {
		Layout,
		PagesBaseTable,
	},

	data() {
		return {
			resource: {
				base: resourceBase,
				proxy() {
					return new Proxy();
				},
				beforeItemsRequest: (res) => {

					if(res.parameters.per_page_custom){
						this.resource.perPage = res.parameters.per_page_custom;
					}
				},
				sortBy: 'created_at',
				sortDesc: true,
				perPage: 9,
				category: 0,
				fields: [
					{
						key: 'id',
						label: 'ID',
						sortable: true,
					},
					{
						key: 'locale',
						label: 'Locale',
						sortable: true
					},
					{
						key: 'title',
						label: 'Title',
						sortable: true,
					},
					{
						key: 'created_at',
						label: 'Created',
						sortable: true,
					},
				],
				searchFields: [
					{
						attribute: 'query',
						component: 'text-field',
						type: 'search',
						placeholder: 'Search ...',
						value: '',
					},
					{
						component: 'select-field',
						attribute: 'per_page_custom',
						placeholder: 'Per items on page',
						ajax: false,
						options: [
							{
								label: "20",
								value: 20
							},
							{
								label: "50",
								value: 50
							},
							{
								label: "100",
								value: 100
							},
							{
								label: "500",
								value: 500
							},
						]
					},

				]
			},
		};
	},
	created() {

	},
	methods: {

	}

};
</script>
